module.exports = __webpack_public_path__ + "static/media/map.25359dc5.png";